import { Injectable } from "@angular/core";
import { LeadRow, ServerSidePaginationInterface } from "../../components/shared/leads-table/leads-table";
import { LeadsDateRangeInteface, LeadsFilaItem, LeadsFilaRequest } from "../../interfaces/leads-fila.interface";
import { PreAprovedHelperService } from "../helpers/pre-approved.helper.service";
import { RenewPlusHelperService } from "../helpers/renew-plus.helper.service";
import { DateUtil } from "../../utils/date-utils";
import { FilterFieldsUtil } from "../../utils/filter-fields-utils";
import { DashboardStoreService } from "../store/dashboard.store.service";

@Injectable({
  providedIn: 'root'
})
export class LeadsDataService {
  constructor(
    private readonly renewPlusHelperService: RenewPlusHelperService,
    private readonly preAprovedHelperService: PreAprovedHelperService,
    private readonly dashboardStoreService: DashboardStoreService,
  ) { }

  mapLeadResponse(leads: LeadsFilaItem[]): LeadRow[] {
    return leads.map((item: LeadsFilaItem) => this.mapLeadRow(item));
  }

  mapLeadRow(item: LeadsFilaItem): LeadRow {
    return {
      idLead: item.idLead,
      nome: item.nomeCliente || '-',
      origem: item.origem || '-',
      contemplacao: item.contemplacao || '-',
      disponivelDesde: item.disponivelDesde || '-',
      terminoContrato: item.terminoContrato || '-',
      dataSimulacao: item.dataSimulacao || '-',
      ultimoContato: (item.ultimoContato && item.ultimoContato !== 'null' && item.ultimoContato !== 'undefined') ? item.ultimoContato : '-',
      retornarEm: (item.retornarEm && item.retornarEm !== 'null' && item.retornarEm !== 'undefined') ? item.retornarEm : '-',
      status: item.statusLead || '-',
      renewal: this.renewPlusHelperService.mapRenovaMais(item),
      preAprovacao: this.preAprovedHelperService.mapPreAprovado(item)
    };
  }

  /*
    TODO: REFACTOR MUITOS PARAMETROS DE ENRADA
  */
  montLeadsFilaRequest(
    tipoCampanha: number,
    dn: number,
    currentFilters: string[],
    currentSearchText: string | undefined,
    dateRange: LeadsDateRangeInteface,
    serverSidePagination: ServerSidePaginationInterface,
    currentSortField: string,
    currentSortOrder?: 'ASC' | 'DESC'
  ): LeadsFilaRequest {
    return {
      tipoCampanha,
      dn,
      preAprovado: FilterFieldsUtil.getPreAprovadoFromFilters(currentFilters),
      renovaMais: FilterFieldsUtil.getRenovaMaisFromFilters(currentFilters),
      origem: FilterFieldsUtil.getOrigemFromFilters(currentFilters),
      nome: currentSearchText,
      dataInicio: DateUtil.parseDate(this.dashboardStoreService.startDate()),
      dataFim: DateUtil.parseDate(this.dashboardStoreService.endDate()),
      page: serverSidePagination.page,
      pageSize: serverSidePagination.pageSize,
      sortField: currentSortField,
      sortOrder: currentSortOrder
    }
  }

}
